// EL CIERRE DEL ALTA, RETOMABLE (ALT-06, 14-10; Francisco: «que no lo haga»).
//
// Lo que viene después de los macros del alta: los macros, las medidas de hoy (con
// entrenador), los dos menús de muestra y, sin entrenador, «Tres cosas y terminamos» hasta
// la oferta de los 87 €. Al llegar a los macros el alta ya está enviada y la ficha dice
// `questionnaire_completed`, así que quien recargaba ahí se encontraba «Ya completaste el
// cuestionario inicial» o «Tu cuestionario se abre el viernes» y esas pantallas no volvían.
//
// Se guarda en la ficha el TIPO de pantalla del cierre en la que va (no su número de paso:
// ese descolocaba al que volvía a por el completo, 23-08), en `ajuste_macros_progreso` con
// `flujo: 'cierre'` (lo escribe `PUT /clients/ajuste-progreso`, regla del servidor en
// `core/progreso_del_cuestionario`). Al volver se retoma por ese tipo, y el alta solo se da
// por terminada al pasar la última o al elegir una de sus salidas («Lo dejo para luego»,
// «Lo hago luego», la oferta).
//
// El cierre empieza en la pantalla de los macros (`result`) y termina en la última del
// recorrido o, con entrenador, en la última antes del cuestionario largo: lo de detrás es
// el completo, que no se retoma desde aquí. Hasta el 20-10 ese corte lo marcaba «¿Seguimos
// ahora o lo dejas para luego?» (`elegir_perfil`); se quitó, y ahora el largo va pegado a
// los menús. Se le reconoce por su final (`final1`) y el cierre son las pantallas del
// cierre seguidas desde los macros.

const PRIMERA = 'result';
const FINAL_DEL_LARGO = 'final1';
const DEL_CIERRE_CON_ENTRENADOR = ['result', 'partida', 'magia'];

/** La pantalla del cierre que esta ficha dejó a medias, o null si no hay ninguna. */
export function cierreDelAltaPendiente(profile) {
    if (!profile?.questionnaire_completed) return null;
    const g = profile.ajuste_macros_progreso;
    if (g?.flujo !== 'cierre') return null;
    const pantalla = typeof g.pantalla === 'string' ? g.pantalla.trim() : '';
    return pantalla || null;
}

const limites = (tipos) => {
    const desde = tipos.indexOf(PRIMERA);
    if (desde < 0) return null;
    if (!tipos.includes(FINAL_DEL_LARGO, desde)) return { desde, hasta: tipos.length - 1 };
    let hasta = desde;
    while (hasta + 1 < tipos.length && DEL_CIERRE_CON_ENTRENADOR.includes(tipos[hasta + 1])) hasta++;
    return { desde, hasta };
};

/** Dónde cae la pantalla `idx` respecto al cierre: 'antes', 'dentro' o 'despues'. */
export function tramoDelCierre(tipos, idx) {
    const l = limites(tipos || []);
    if (!l || idx < l.desde) return 'antes';
    return idx > l.hasta ? 'despues' : 'dentro';
}

/** El índice por el que retomar el cierre en ESTE recorrido: el de la pantalla guardada si
 *  sigue en su cierre (el plan puede haber cambiado), y si no, el de los macros. -1 si este
 *  recorrido no tiene cierre. */
export function dondeRetomarElCierre(tipos, pantalla) {
    const l = limites(tipos || []);
    if (!l) return -1;
    const i = tipos.indexOf(pantalla, l.desde);
    return i >= 0 && i <= l.hasta ? i : l.desde;
}
